import { render, staticRenderFns } from "./VideoSlider.vue?vue&type=template&id=17e5f49d"
import script from "./VideoSlider.vue?vue&type=script&lang=js"
export * from "./VideoSlider.vue?vue&type=script&lang=js"
import style0 from "./VideoSlider.vue?vue&type=style&index=0&id=17e5f49d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports